<template lang="pug">
    form.form
        .form__text.form__text--margin Инструкция по установке кнопки виджета на странице Вконтакте по
            a(href="#") ссылке.
        h3.h3 Счетчик Яндекс.Метрики
        .form__group
            label.form__label Введите id счетчика
            input(type='text').form__input.form__input--big

        a(href='#').btn.btn--big Сохранить
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss">
  
</style>
